import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'

export type CheckMeshfaStatusRequestPayload = {
  triggerReauthIfNeeded?: boolean
  forceTrigger?: boolean
}

export const CheckMeshfaStatusRequestPayloadSchema: CborSchema<CheckMeshfaStatusRequestPayload> =
  defineCborSchema<CheckMeshfaStatusRequestPayload>({
    triggerReauthIfNeeded: CborField({ key: 0, required: false }),
    forceTrigger: CborField({ key: 1, required: false }),
  })
